
<template>
  <main>
    <fade-in-top-title class="title-interval">
      <h3>Pf fashion</h3>
      <span>Html/Css/Js</span>
    </fade-in-top-title>
    <div class="container container-web">
      <work-contents-top>
        <img src="@/assets/images/workContents03_pc.png" alt="">
      </work-contents-top>
      <work-contents-text-me
      webSiteText="個人的に制作した架空の店「Pf fashion」のWebサイトです。"
      webSiteTextContentsFirst="フリーの動画素材を動画編集で繋げて「pf fashion」としてメインビジュアルにしました。"
      webSiteTextContentsSecound="以下、コンテンツ箇所になります"/>
      <div class="work-contents-wrapper">
        <work-contents-block title="MainVisual">
          <div class="work-contents-group">
            <img class="pc" src="@/assets/images/workContents03_pc_01.png" alt="">
            <img class="sp" src="@/assets/images/workContents03_sp_01.png" alt="">
          </div>
        </work-contents-block>
        <work-contents-block title="「MainVisual」の動画機能の挙動はこちら">
          <div class="gif" @click="gifClick01">
            <img :src="gif01.src" alt="" :id="1">
            <play-icon v-show="show01"></play-icon>
          </div>
        </work-contents-block>
        <work-contents-block title="News">
          <div class="work-contents-group">
            <img class="pc" src="@/assets/images/workContents03_pc_02.png" alt="">
            <img class="sp" src="@/assets/images/workContents03_sp_02.png" alt="">
          </div>
        </work-contents-block>
        <work-contents-block title="「News」のスライダー及びモーダル機能の挙動はこちら">
          <div class="gif" @click="gifClick02">
            <img :src="gif02.src" alt="" :id="1">
            <play-icon v-show="show02"></play-icon>
          </div>
        </work-contents-block>
        <work-contents-block title="Genre">
          <div class="work-contents-group">
            <img class="pc" src="@/assets/images/workContents03_pc_03.png" alt="">
            <img class="sp" src="@/assets/images/workContents03_sp_03.png" alt="">
          </div>
        </work-contents-block>
        <work-contents-block title="「Genre」のパララックス機能の挙動はこちら">
          <div class="gif" @click="gifClick03">
            <img :src="gif03.src" alt="" :id="1">
            <play-icon v-show="show03"></play-icon>
          </div>
        </work-contents-block>
        <work-contents-block title="SNS">
          <div class="work-contents-group">
            <img class="pc" src="@/assets/images/workContents03_pc_04.png" alt="">
            <img class="sp" src="@/assets/images/workContents03_sp_04.png" alt="">
          </div>
        </work-contents-block>
        <work-contents-block title="「SNS」のアニメーション機能の挙動はこちら">
          <div class="gif" @click="gifClick04">
            <img :src="gif04.src" alt="" :id="1">
            <play-icon v-show="show04"></play-icon>
          </div>
        </work-contents-block>
      </div>
    </div>
    <router-link to="/work/workContents02">
      <work-slide-left></work-slide-left>
    </router-link>
    <router-link to="/work/workContents04">
      <work-slide-right></work-slide-right>
    </router-link>
  </main>
</template>



<script>
import FadeInTopTitle from '@/components/FadeInTopTitle.vue';
import WorkContentsTextMe from '@/components/WorkContentsTextMe.vue';
import WorkContentsTop from '@/components/WorkContentsTop.vue';
import WorkContentsBlock from '@/components/WorkContentsBlock.vue';
import WorkSlideLeft from '@/components/WorkSlideLeft.vue';
import WorkSlideRight from '@/components/WorkSlideRight.vue';
import PlayIcon from '@/components/PlayIcon.vue';

export default {
  data() {
    return {
      gif01: {
        src: require('@/assets/gifs/workContents03-01_play.gif')
      },
      gif02: {
        src: require('@/assets/gifs/workContents03-02_play.gif')
      },
      gif03: {
        src: require('@/assets/gifs/workContents03-03_play.gif')
      },
      gif04: {
        src: require('@/assets/gifs/workContents03-04_play.gif')
      },
      show01: true,
      show02: true,
      show03: true,
      show04: true,
    }
  },
  components: {
    FadeInTopTitle,
    WorkContentsTextMe,
    WorkContentsTop,
    WorkContentsBlock,
    WorkSlideLeft,
    WorkSlideRight,
    PlayIcon
  },
  methods: {
    gifClick01() {
      this.show01 = !this.show01;
      if(this.show01) {
        this.gif01.src = require('@/assets/gifs/workContents03-01_play.gif');
      } else {
      this.gif01.src = require('@/assets/gifs/workContents03-01.gif');
      }
    },
    gifClick02() {
      this.show02 = !this.show02;
      if(this.show02) {
        this.gif02.src = require('@/assets/gifs/workContents03-02_play.gif');
      } else {
      this.gif02.src = require('@/assets/gifs/workContents03-02.gif');
      }
    },
    gifClick03() {
      this.show03 = !this.show03;
      if(this.show03) {
        this.gif03.src = require('@/assets/gifs/workContents03-03_play.gif');
      } else {
      this.gif03.src = require('@/assets/gifs/workContents03-03.gif');
      }
    },
    gifClick04() {
      this.show04 = !this.show04;
      if(this.show04) {
        this.gif04.src = require('@/assets/gifs/workContents03-04_play.gif');
      } else {
      this.gif04.src = require('@/assets/gifs/workContents03-04.gif');
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>